<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs" />
    <heading>{{ year }}</heading>
    <reportQuickActions feature="medkitlog" />
    <dateFolderTable
      :rows="rows"
      :loading="loading"
      :nameLabel="$t('folders.month')"
      @open="openMonth"
    />
  </div>
</template>

<script>
import dateFolderTable from "../../components/_utils/dateFolderTable.vue";
import reportQuickActions from "../../components/_utils/reportQuickActions.vue";
import i18n from "../../i18n";
import { monthLabel } from "../../utils/monthLabel";

export default {
  name: "medkitlogMonths",
  components: { dateFolderTable, reportQuickActions },
  data: () => ({ counts: {}, loading: false }),
  async created() {
    this.loading = true;
    try {
      this.counts =
        (await this.$store.dispatch("getMedkitlogMonthCounts", this.year)) ||
        {};
    } finally {
      this.loading = false;
    }
  },
  computed: {
    year() {
      return this.$route.params.year;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("sidebar.medkitlogs"),
          disabled: false,
          href: "/app/medkitlogs",
        },
        { text: this.year, disabled: true },
      ];
    },
    rows() {
      const rows = [];
      for (let m = 1; m <= 12; m++) {
        rows.push({
          key: String(m),
          label: monthLabel(m, this.$i18n.locale),
          total: (this.counts[String(m)] || {}).total || 0,
        });
      }
      return rows;
    },
  },
  methods: {
    openMonth(row) {
      this.$router.push({
        name: "medkitlogByMonth",
        params: { year: this.year, month: row.key },
      });
    },
  },
};
</script>
